import {
  BulkUpdateTaskConfigurationFilesDocument,
  BulkUpdateTaskConfigurationFilesMutationVariables,
  GetTaskConfigurationFilesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'

export const useBulkUpdateTaskConfigurationFiles = () => {
  const [bulkUpdateFiles] = useMutation(BulkUpdateTaskConfigurationFilesDocument, {
    extractorFn: (data) =>
      data.processesMutations.bulkUpdateProcessesConfigurationTaskConfigurationFile,
  })

  const createTaskConfigurationFile = async (
    variables: BulkUpdateTaskConfigurationFilesMutationVariables,
    taskConfigurationId: string
  ) => {
    const rawResult = await bulkUpdateFiles({
      variables,
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetTaskConfigurationFilesDocument,
          variables: {
            taskConfigurationId: taskConfigurationId,
          },
        },
      ],
    })

    const result = handleResult(rawResult, (errors) => {
      throw 'Could not update files: ' + JSON.stringify(errors)
    })

    if (!result.success) {
      throw 'Could not update files: ' + JSON.stringify(result.errors)
    }

    return result.data.taskConfigurationFiles
  }

  return createTaskConfigurationFile
}
